import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-4 py-2 px-4 pt-1 w-full max-w-full flex-grow-0" }
const _hoisted_2 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_3 = { class: "flex gap-2 flex-row justify-center items-center text-gray-700" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "WhatsApp", -1)
const _hoisted_5 = { class: "flex gap-2 flex-row justify-center items-center text-gray-700" }
const _hoisted_6 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_7 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_8 = { class: "col-span-2 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_9 = { class: "col-span-3 flex flex-col max-w-1/6 h-full items-start justify-end gap-1.5" }
const _hoisted_10 = { class: "col-span-1 flex flex-shrink flex-row max-w-1/6 h-full items-end justify-end align-center gap-1.5" }

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import Label from '@/components/ui/label/Label.vue';
import ProviderIcon from '@/components/ProviderIcon.vue';
import { PostPartnerProviderPayload } from '@/http/partnerProvider';
import Input from '@/components/ui/input/Input.vue';
import Avatar from '@/components/ui/avatar/Avatar.vue';
import { POST_PARTNER_PROVIDERS, PARTNER_ID } from '@/store';
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';
import Button from '@/components/ui/button/Button.vue';
import { CircleCheck, CircleX } from 'lucide-vue-next';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerProviderCreationForm',
  props: {
    displayToast: {
        type: Function,
        required: true
    }
},
  emits: ['cancel', 'creation-finished'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();

const idInProvider = ref<string | undefined>(undefined);
const partnerProviderType = ref<"WHATSAPP" | "INSTAGRAM" | undefined>(undefined);
const presentationNameInProvider = ref<string | undefined>(undefined);
const tokenInProvider = ref<string | undefined>(undefined);
const webhookVerificationToken = ref<string | undefined>(undefined);

const validateNotEmptyString = (value?: string): boolean => {
    return value !== undefined && value.trim() !== '';
};

const validatePartnerProviderType = (value?: string): boolean => {
    return value === 'WHATSAPP' || value === 'INSTAGRAM';
};

const showPartnerProviderTypeInvalidMessage = ref<boolean | undefined>(undefined);
watch(partnerProviderType, (newValue) => {
    showPartnerProviderTypeInvalidMessage.value = !validatePartnerProviderType(newValue);
});

const showIdInProviderInvalidMessage = ref<boolean | undefined>(undefined);
watch(idInProvider, (newValue) => {
    showIdInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});
const showWebhookVerificationInvalidMessage = ref<boolean | undefined>(undefined);
watch(webhookVerificationToken, (newValue) => {
    showWebhookVerificationInvalidMessage.value = !validateNotEmptyString(newValue);
});

const showTokenInProviderInvalidMessage = ref<boolean | undefined>(undefined);
watch(tokenInProvider, (newValue) => {
    showTokenInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});

const showPresentationNameInProviderInvalidMessage = ref<boolean | undefined>(undefined);
watch(presentationNameInProvider, (newValue) => {
    showPresentationNameInProviderInvalidMessage.value = !validateNotEmptyString(newValue);
});

const isFormValid = computed(() =>
    validateNotEmptyString(idInProvider.value) &&
    validatePartnerProviderType(partnerProviderType.value) &&
    validateNotEmptyString(presentationNameInProvider.value) &&
    validateNotEmptyString(tokenInProvider.value) &&
    validateNotEmptyString(webhookVerificationToken.value)
);
const getInvalidParametersMessages = () => {
    let errors = `${showPartnerProviderTypeInvalidMessage.value ? "Tipo do Provedor, \n" : ""}` +
        `${showPresentationNameInProviderInvalidMessage.value ? "Nome de Apresentação, \n" : ""}` +
        `${showIdInProviderInvalidMessage.value ? "Identificação no Provedor, \n" : ""}` +
        `${showTokenInProviderInvalidMessage.value ? "Token no Provedor, \n" : ""}` +
        `${showWebhookVerificationInvalidMessage.value ? "Webhook Verification Token, \n" : ""}`;
    let messages = 'Você também precisa preencher os seguintes campos: ' + errors.slice(0, errors.length - 3) + '.';

    return messages;
};

const emit = __emit;
const postPartnerProvider = async () => {
    const localPartnerId = localStorage.getItem(PARTNER_ID);

    if (localPartnerId === null) return;

    if (!isFormValid.value) {
        showIdInProviderInvalidMessage.value = !(validateNotEmptyString(idInProvider.value));
        showTokenInProviderInvalidMessage.value = !(validateNotEmptyString(tokenInProvider.value));
        showPartnerProviderTypeInvalidMessage.value = !(validateNotEmptyString(partnerProviderType.value));
        showWebhookVerificationInvalidMessage.value = !(validateNotEmptyString(webhookVerificationToken.value));
        showPresentationNameInProviderInvalidMessage.value = !(validateNotEmptyString(presentationNameInProvider.value));

        const invalidFieldsMessages = getInvalidParametersMessages();

        props.displayToast('Há dados inválidos!', 'destructive', invalidFieldsMessages);
        return;
    }
    const payload: PostPartnerProviderPayload = {
        partnerId: localPartnerId,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        idInProvider: idInProvider.value!,
        partnerProviderType: partnerProviderType.value as "WHATSAPP" | "INSTAGRAM",
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        presentationNameInProvider: presentationNameInProvider.value!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tokenInProvider: tokenInProvider.value!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        webhookVerificationToken: webhookVerificationToken.value!,
    };
    await store.dispatch(POST_PARTNER_PROVIDERS, payload);

    props.displayToast('As informações do provedor foram adicionadas com sucesso!', 'default');
    emit('creation-finished');
};

const handleCancel = () => {
    emit('cancel');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Label, {
        class: _normalizeClass({ 'text-red-500 border-red-500': showPartnerProviderTypeInvalidMessage.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode("Provedor")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(Select), {
        modelValue: partnerProviderType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((partnerProviderType).value = $event)),
        class: "max-w-full rounded-lg"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectTrigger), {
            class: _normalizeClass(["w-full flex-grow-0 shrink-0 text-gray-500", { 'border-red-500 text-red-500': showPartnerProviderTypeInvalidMessage.value }])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectValue), { placeholder: "Selecione" })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(SelectContent), null, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectGroup), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(SelectItem), { value: 'WHATSAPP' }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(Avatar, {
                          size: "icon",
                          shape: "frame"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ProviderIcon, { provider: 'WHATSAPP' })
                          ]),
                          _: 1
                        }),
                        _hoisted_4
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(SelectItem), { value: 'INSTAGRAM' }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(Avatar, {
                          size: "icon",
                          class: "w-6 h-6 bg-white rounded-lg"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(ProviderIcon, { provider: 'INSTAGRAM' })
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Instagram ")
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Label, {
        class: _normalizeClass({ 'text-red-500 border-red-500': showPresentationNameInProviderInvalidMessage.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Nome de Apresentação")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({ 'ring-red-500  border-red-500': showPresentationNameInProviderInvalidMessage.value }),
        modelValue: presentationNameInProvider.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((presentationNameInProvider).value = $event))
      }, null, 8, ["class", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(Label, {
        class: _normalizeClass({ 'text-red-500 border-red-500': showIdInProviderInvalidMessage.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Identificação do Provedor")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({ 'ring-red-500 border-red-500': showIdInProviderInvalidMessage.value }),
        modelValue: idInProvider.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((idInProvider).value = $event))
      }, null, 8, ["class", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(Label, {
        class: _normalizeClass({ 'text-red-500 border-red-500': showTokenInProviderInvalidMessage.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Token")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({ 'ring-red-500 border-red-500': showTokenInProviderInvalidMessage.value }),
        modelValue: tokenInProvider.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tokenInProvider).value = $event))
      }, null, 8, ["class", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(Label, {
        class: _normalizeClass({ 'text-red-500': showWebhookVerificationInvalidMessage.value })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Webhook Verification Token")
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Input, {
        class: _normalizeClass({ 'ring-red-500 border-red-500': showWebhookVerificationInvalidMessage.value }),
        modelValue: webhookVerificationToken.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((webhookVerificationToken).value = $event))
      }, null, 8, ["class", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(Button, {
        variant: "ghost",
        size: "icon",
        onClick: handleCancel
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CircleX), { class: "text-slate-400" })
        ]),
        _: 1
      }),
      _createVNode(Button, {
        variant: "default",
        size: "icon",
        onClick: postPartnerProvider
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CircleCheck), { class: "text-white" })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})